import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import {
  ShipperRepository,
  type GetShippersParams,
  type GetShippersResult,
} from '../infra/ShipperRepository'

export type GetShippersFactoryDependencies = {
  shipperRepository: ShipperRepository
}

export function getShippersFactory({ shipperRepository }: GetShippersFactoryDependencies) {
  return async function getShippersImpl(
    params: GetShippersParams = {},
    config?: { signal?: AbortSignal }
  ): Promise<GetShippersResult> {
    return shipperRepository.getShippers(params, config)
  }
}

export function getShippers(
  params: GetShippersParams = {},
  config?: { signal?: AbortSignal }
): Promise<GetShippersResult> {
  const httpClient = new HttpClient(API_URL)
  const shipperRepository = new ShipperRepository({ httpClient })
  const newGetShippers = getShippersFactory({ shipperRepository })
  return newGetShippers(params, config)
}
